import { FaAmazon, FaAppStore, FaCreditCard, FaDiscord, FaEnvelope, FaGithub, FaGooglePlay, FaInstagram, FaLinkedin, FaMusic, FaPinterestP, FaPodcast, FaSnapchat, FaSoundcloud, FaSpotify, FaTelegram, FaTiktok, FaTwitch, FaTwitter, FaWhatsapp, FaYoutube } from 'react-icons/fa'
import { FaFacebookF, FaThreads } from 'react-icons/fa6'
import { SiClubhouse } from 'react-icons/si'

export const iconsEntriesMock = [
  {
    icon: <FaSnapchat />,
    name: 'Snapchat',
    enabled: false,
    exampleUrl: 'https://www.snapchat.com/add/yourusername',
  },
  {
    icon: <FaInstagram />,
    name: 'Instagram',
    enabled: false,
    exampleUrl: '@instagramusername',
  },
  {
    icon: <FaThreads />,
    name: 'Threads',
    enabled: false,
    exampleUrl: '@threadsusername',
  },
  {
    icon: <FaEnvelope />,
    name: 'Email',
    enabled: false,
    exampleUrl: 'your@emailaddress.com',
  },
  {
    icon: <FaFacebookF />,
    name: 'Facebook',
    enabled: false,
    exampleUrl: 'https://facebook.com/facebookpageurl',
  },
  {
    icon: <FaYoutube />,
    name: 'Youtube',
    enabled: false,
    exampleUrl: 'https://youtube.com/channel/youtubechannelurl',
  },
  {
    icon: <FaTwitter />,
    name: 'X (Twitter)',
    enabled: false,
    exampleUrl: '@yourxhandle',
  },
  {
    icon: <FaTiktok />,
    name: 'Tiktok',
    enabled: false,
    exampleUrl: '@tiktokusername',
  },
  {
    icon: <FaWhatsapp />,
    name: 'Whatsapp',
    enabled: false,
    exampleUrl: 'https://wa.me/12345678',
  },
  {
    icon: <FaTelegram />,
    name: 'Telegram',
    enabled: false,
    exampleUrl: 'https://t.me/',
  },
  {
    icon: <FaAmazon />,
    name: 'Amazon',
    enabled: false,
    exampleUrl: 'https://amazon.com/shop/yourshopname',
  },
  {
    icon: <FaGooglePlay />,
    name: 'Android Play Store',
    enabled: false,
    exampleUrl: 'https://play.google.com/store/apps/details?url=com.yourapp.app',
  },
  {
    icon: <FaAppStore />,
    name: 'Apple App Store',
    enabled: false,
    exampleUrl: 'https://apps.apple.com/us/yourapp/url1234567890',
  },
  {
    icon: <FaMusic />,
    name: 'Apple Music',
    enabled: false,
    exampleUrl: 'https://music.apple.com/us/album/youralbum',
  },
  {
    icon: <FaPodcast />,
    name: 'Apple Podcast',
    enabled: false,
    exampleUrl: 'https://podcasts.apple.com/us/podcast/yourpodcast/123456789',
  },
  {
    icon: <SiClubhouse />,
    name: 'Clubhouse',
    enabled: false,
    exampleUrl: 'https://clubhouse.com/@profile',
  },
  {
    icon: <FaDiscord />,
    name: 'Discord',
    enabled: false,
    exampleUrl: 'https://discord.com/invite/yourchannel',
  },
  {
    icon: <FaGithub />,
    name: 'Github',
    enabled: false,
    exampleUrl: 'https://www.github.com/username',
  },
  {
    icon: <FaLinkedin />,
    name: 'Linkedin',
    enabled: false,
    exampleUrl: 'https://linkedin.com/in/username',
  },
  {
    icon: <FaCreditCard />,
    name: 'Payment',
    enabled: false,
    exampleUrl: 'https://paypal.me/yourusername',
  },
  {
    icon: <FaPinterestP />,
    name: 'Pinterest',
    enabled: false,
    exampleUrl: 'https://pinterest.com/',
  },
  {
    icon: <FaSpotify />,
    name: 'Spotify',
    enabled: false,
    exampleUrl: 'https://open.spotify.com/artist/artistname',
  },
  {
    icon: <FaTwitch />,
    name: 'Twitch',
    enabled: false,
    exampleUrl: 'https://twitch.tv/',
  },
  {
    icon: <FaSoundcloud />,
    name: 'Soundcloud',
    enabled: false,
    exampleUrl: 'https://soundcloud.com/username',
  }
]

